export type OptionType = {
  __typename?: 'OptionType';
  imageUrl?: string | null;
  label: string;
  value: string;
};

export enum Role {
  Admin = 'ADMIN',
  AuxiliaryNurse = 'AUXILIARY_NURSE',
  Clinic = 'CLINIC',
  Doctor = 'DOCTOR',
  Nurse = 'NURSE',
  Patient = 'PATIENT',
  Secretary = 'SECRETARY',
}

export enum DrugDurationMeasures {
  Giorni = 'GIORNI',
  Mesi = 'MESI',
  Settimane = 'SETTIMANE',
}

export enum DrugTimeMeasures {
  AlBisogno = 'AL_BISOGNO',
  Giorni = 'GIORNI',
  Mesi = 'MESI',
  Ore = 'ORE',
  Settimane = 'SETTIMANE',
}

export enum DrugUnitMeasures {
  Amp = 'AMP',
  App = 'APP',
  Bar = 'BAR',
  Bas = 'BAS',
  Bom = 'BOM',
  Bus = 'BUS',
  Car = 'CAR',
  Cc = 'CC',
  Cer = 'CER',
  Cli = 'CLI',
  Cmo = 'CMO',
  Cpr = 'CPR',
  Cps = 'CPS',
  Cro = 'CRO',
  Div = 'DIV',
  Dos = 'DOS',
  Ero = 'ERO',
  Fia = 'FIA',
  Fil = 'FIL',
  Fla = 'FLA',
  G = 'G',
  Gar = 'GAR',
  Gra = 'GRA',
  Grn = 'GRN',
  Gtt = 'GTT',
  Imp = 'IMP',
  Inp = 'INP',
  Ins = 'INS',
  Iud = 'IUD',
  Lio = 'LIO',
  Mc = 'MC',
  Mcg = 'MCG',
  Meq = 'MEQ',
  Mg = 'MG',
  Ml = 'ML',
  Mtr = 'MTR',
  Neb = 'NEB',
  Ovu = 'OVU',
  Pas = 'PAS',
  Pen = 'PEN',
  Sac = 'SAC',
  Sir = 'SIR',
  Spu = 'SPU',
  Sup = 'SUP',
  Tam = 'TAM',
  Tub = 'TUB',
  U = 'U',
  Ual = 'UAL',
  Ui = 'UI',
  Vas = 'VAS',
}

export interface AvatarParameters {
  avatarUrl: string | null | undefined;
  role: Role;
}
